import React from 'react';

import cn from 'classnames';

import Icon, { Glyph } from '../icon/icon';

// styles
import css from './pseudolink.css';

type Props = {
    color?: 'content' | 'red' | 'dark' | 'green';
    name?: string;
    type?: 'dashed' | 'underlined' | 'normal';
    disabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
    glyph?: Glyph;
    dataQa?: string;
    className?: string;
};

const PseudoLink: React.FC<React.PropsWithChildren<Props>> = (props) => {
    const { children, name, color, type, disabled, onClick, glyph } = props;
    const totalClasses = cn('ui-pseudolink', css.root, props.className, {
        [css.colorContent]: color === 'content',
        [css.colorRed]: color === 'red',
        [css.colorDark]: color === 'dark',
        [css.colorGreen]: color === 'green',
        [css.typeDashed]: type === 'dashed',
        [css.typeUnderlined]: type === 'underlined',
        [css.typeNormal]: type === 'normal',
        [css.stateDisabled]: disabled,
    });
    const clickHandler = !disabled ? onClick : undefined;

    return (
        <span
            title={name}
            className={totalClasses}
            onClick={clickHandler}
            data-qa={props.dataQa}
        >
            {glyph && (
                <span className={css.icon}>
                    <Icon glyph={glyph} />
                </span>
            )}
            {children}
        </span>
    );
};

export default PseudoLink;
